import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from '../service/autenticacao/auth.service';
import { AppAuthService } from 'src/app/service/auth/auth.service';
import {Router} from '@angular/router';
import {PAGINA_HOME, PAGINA_HOME_USUARIO_INTERNO, URL_API} from 'src/app/tools/URL';
import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {
  MENSAGEM_EXPIRAR_SESSAO,
  ERRO_COMUNICACAO_SERVIDOR,
  ERRO_SERVIDOR,
  MENSAGEM_SESSAO_EXPIRADA,
  MENSAGEM_SESSAO_EXPIRADA_GOV_BR
} from 'src/app/tools/Mensagens';
import {environment} from 'src/app/environment';
import {build} from '../../build/build';
import {CARREGAR} from '../service/errors/errors.service';

const TOKEN_HEADER_KEY = 'External-Authorization';
const TIMEOUT_SESSION = 'TimeoutSession';
const TEMPO_SESSAO = 1140000; //19 min (tempo que solicita a renovação do token. Sessão do back-end encerra com 20 min)

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, protected router: Router, protected keycloakService: KeycloakService, private appAuthService: AppAuthService) {}

  private tratarErroUsuarioInterno(err: HttpErrorResponse, req: HttpRequest<any>, fluxo: string): void {
    if (err.status === 401) {
      //console.log('[DiagnosticoAuth] Logout por erro HTTP', { fluxo, metodo: req.method, status: err.status });
      this.authService.logoutUser();
    } else if (err.status === 403) {
      this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
    } else if (err.status === 0 || err.status >= 500) {
      //console.log('[DiagnosticoAuth] Erro HTTP sem logout', { fluxo, metodo: req.method, status: err.status });
      alert(err.status === 0 ? ERRO_COMUNICACAO_SERVIDOR : ERRO_SERVIDOR);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;

    return new Observable(observer => {

      try {
        const apiUrl = (environment.settings && environment.settings.api && environment.settings.api.url) ? environment.settings.api.url : '';
        if (req.url && apiUrl && !req.url.toString().startsWith(apiUrl)) {
          // allow non-API calls (fonts, scripts, etc.) to pass through without auth checks
          return next.handle(req).subscribe(event => {
            if (event instanceof HttpResponse) { observer.next(event); }
          }, err => { observer.error(err); }, () => { observer.complete(); });
        }
      } catch (e) {
        // ignore and continue with normal flow
      }

      // 1) External user
      if (this.authService.isUsuarioExternoLogado()) {
        const tokenExternal = this.authService.getTokenUsuarioExterno();
        if (tokenExternal) {
          try {
            const apiUrl = environment.settings.api.url || '';
            if (req.url && req.url.toString().startsWith(apiUrl)) {
              authReq = req.clone({headers: req.headers.set(TOKEN_HEADER_KEY, tokenExternal)});
            }
          } catch (e) {
            // fallback: do not attach if anything goes wrong
          }
        }

        return next.handle(authReq).subscribe(
          event => {
            if (event instanceof HttpResponse) {
              observer.next(event);
            }
          },
          err => {
            if (err.status === 401) {
              //console.log('[DiagnosticoAuth] Logout EXTERNO por erro HTTP', { metodo: req.method, status: err.status });
              this.authService.logoutUser();
              alert(MENSAGEM_SESSAO_EXPIRADA);
            } else if (err.status === 403) {
              this.router.navigate([PAGINA_HOME]);
            }

            if (err.url && err.url.includes('/cpe')) {
              if (err.error && err.error.length > 0) {
                const mensagens = err.error.map((erro: any) => erro.mensagem).join('\n');
                alert(mensagens);
              }
            }

            if (err.url && err.url.includes('/consulta')) {
              if (err.error) {
                if (Array.isArray(err.error) && err.error.length > 0) {
                  const mensagens = err.error.map((erro: any) => erro.mensagem).join('\n');
                  alert(mensagens);
                } else if (Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                  const mensagens = err.error.errors.join('\n');
                  alert(mensagens);
                }
              }
            }

            observer.complete();
          },
          () => {
            try {
              if (authReq.url === environment.settings.api.url + URL_API.PATH_USUARIO_AUTENTICADO) {
                build.timeoutSessao = (setTimeout(() => {
                  if (confirm(MENSAGEM_EXPIRAR_SESSAO)) {
                    this.authService.refreshToken();
                  }
                }, TEMPO_SESSAO) as any);

                const dataExpiracao = new Date();
                dataExpiracao.setTime(Date.now() + TEMPO_SESSAO);
                localStorage.setItem(TIMEOUT_SESSION, dataExpiracao.getTime().toString());
              }

              const checkPaths = [
                URL_API.PATH_CONSULTA,
                URL_API.PATH_CRITICA,
                URL_API.PATH_DENUNCIA,
                URL_API.PATH_ELOGIO,
                URL_API.PATH_INFORMACAO,
                URL_API.PATH_LGPD,
                URL_API.PATH_RECLAMACAO,
                URL_API.PATH_SOLICITACAO,
                URL_API.PATH_SUGESTAO
              ];

              for (const p of checkPaths) {
                if (authReq.url === environment.settings.api.url + p + '/' + CARREGAR) {
                  build.timeoutSessao = (setTimeout(() => {
                    if (confirm(MENSAGEM_EXPIRAR_SESSAO)) {
                      this.authService.refreshToken();
                    }
                  }, TEMPO_SESSAO) as any);
                }
              }
            } catch (e) {
              // ignore
            }

            observer.complete();
          }
        );

      // 2) Gov.BR user
      } else if (this.authService.isUsuarioGovBr()) {
        return next.handle(authReq).subscribe(
          event => {
            if (event instanceof HttpResponse) {
              observer.next(event);
            }
          },
          err => {
            if (err.status === 401) {
              //console.log('[DiagnosticoAuth] Logout GOVBR por erro HTTP', { metodo: req.method, status: err.status });
              this.authService.logoutUser();
              alert(MENSAGEM_SESSAO_EXPIRADA);
            } else if (err.status === 403) {
              this.router.navigate([PAGINA_HOME]);
            }
            observer.complete();
          },
          () => {
            build.timeoutSessao = (setTimeout(() => {
              //console.log('[DiagnosticoAuth] Logout GOVBR por timeout de sessao', { tempoSessaoMs: TEMPO_SESSAO });
              this.authService.logoutUserGovBr();
              alert(MENSAGEM_SESSAO_EXPIRADA_GOV_BR);
            }, TEMPO_SESSAO) as any);
            observer.complete();
          }
        );

      // 3) Internal users - Keycloak or AppAuthService
      } else {
        try {
          if (this.appAuthService && this.appAuthService.hasValidAccessToken()) {
            const token = this.appAuthService.getAccessToken();
            if (token && this.router.url !== PAGINA_HOME && !req.url.includes(URL_API.PATH_VIA_CEP)) {
              authReq = req.clone({setHeaders: {Authorization: 'Bearer ' + token}});
              return next.handle(authReq).subscribe(
                event => { if (event instanceof HttpResponse) { observer.next(event); } },
                err => {
                  this.tratarErroUsuarioInterno(err, req, 'OIDC');
                  observer.error(err);
                },
                () => observer.complete()
              );
            }
          }
        } catch (e) {
          // ignore and fallback to keycloak adapter
        }

        this.keycloakService.isLoggedIn().then(isLoggerIn => {
          if (isLoggerIn && this.router.url !== PAGINA_HOME && !req.url.includes(URL_API.PATH_VIA_CEP)) {
            this.keycloakService.getToken().then(token => {
              authReq = req.clone({setHeaders: {Authorization: 'Bearer ' + token}});
              return next.handle(authReq).subscribe(
                event => {
                  if (event instanceof HttpResponse) {
                    observer.next(event);
                  }
                },
                err => {
                  this.tratarErroUsuarioInterno(err, req, 'KEYCLOAK_ADAPTER');
                  observer.error(err);
                },
                () => observer.complete()
              );
            });
          } else if (this.appAuthService && this.appAuthService.hasValidAccessToken() && this.router.url !== PAGINA_HOME && !req.url.includes(URL_API.PATH_VIA_CEP)) {
            const token = this.appAuthService.getAccessToken();
            if (token) {
              authReq = req.clone({setHeaders: {Authorization: 'Bearer ' + token}});
            }
            return next.handle(authReq).subscribe(
              event => {
                if (event instanceof HttpResponse) {
                  observer.next(event);
                }
              },
              err => {
                this.tratarErroUsuarioInterno(err, req, 'OIDC_FALLBACK');
                observer.error(err);
              },
              () => observer.complete()
            );
          } else {
            return next.handle(authReq).subscribe(
              event => {
                if (event instanceof HttpResponse) {
                  observer.next(event);
                }
              },
              err => {
                this.tratarErroUsuarioInterno(err, req, 'SEM_TOKEN_INTERNO');
                observer.error(err);
              },
              () => observer.complete()
            );
          }
        });
      }

      return () => observer.unsubscribe();
    });
  }
}
